import {isDevelopmentBuild} from "../utils/constants";

export enum SuspenseStatus {
    Pending = "pending",
    Success = "success",
    Error = "error"
}

export enum SentimentType {
    Positive = "POSITIVE",
    Negative = "NEGATIVE",
    Mixed = "MIXED",
    Neutral = "NEUTRAL"
}

export enum Status {
    Default = 'Default',
    Loading = "Loading",
    Success = "Success",
    Error = "Error",
    Unauthorized = "Unauthorized"
}

// Uncomment when MSBuild process is fixed
export const siteKey = isDevelopmentBuild ? "6Le1_0AUAAAAAPoseWaJmTr10ouU-p0fY0KP7Tt3" : "6LcAM0wUAAAAAMJXkQTqAz8IKNBJHdmBRF2ZUo9l"

export enum ContactGroupEnumType {
    CustomerService = 'CustomerService',
    DigitalSignageSupport = 'DigitalSignageSupport',
    ArtworkService = 'ArtworkService',
    TabletSupport = 'TabletSupport',
    LocalPickUp = 'LocalPickUp',
    Rentals = 'Rentals',
    Warranties = 'Warranties',
    SalesTeam = 'SalesTeam',
    Installation = 'DigitalInstallation'
}

export enum PromotionEnumType {
    Unknown = 'Unknown',
    SingleProduct = 'SingleProduct',
    ProductGroup = 'ProductGroup',
    SingleUseCode = 'SingleUseCode'
}

export enum RecommendationType {
    UsersWhoViewedAlsoViewed = "UsersWhoViewedAlsoViewed",
    UsersWhoBoughtAlsoBought = "UsersWhoBoughtAlsoBought"
}

export enum VideoEnumType {
    ProductIntro = 'ProductIntro',
    AssemblyHowTo = 'AssemblyHowTo',
    ProductSeriesShowcase = 'ProductSeriesShowcase',
    UserSubmitted = 'UserSubmitted',
    CompanySpotlight = 'CompanySpotlight',
    Events = 'Events',
    DiyIdeas = 'DiyIdeas',
    DesignerHowTo = 'DesignerHowTo',
    ProductOnly = 'ProductOnly'
}

export enum ProductConnectionType {
    Unknown = 'Unknown',
    CrossSell = 'CrossSell',
    Compatible = 'Compatible',
    Replacement = 'Replacement'
}

export enum ArtworkGuidelineType {
    None = 'None',
    GeneralArtworkDescription = 'GeneralArtworkDescription',
    Banners = 'GeneralArtworkDescription',
    DigitalThrowsAndRunners = 'DigitalThrowsAndRunners',
    HeatTransferThrowsAndRunners = 'HeatTransferThrowsAndRunners',
    Headers = 'Headers',
    TextOnly = 'TextOnly',
    DigitalFlags = 'DigitalFlags',
    SilkscreenFlags = 'SilkscreenFlags',
    DigitalPopov = 'DigitalPopov',
    TradeWinds = 'TradeWinds',
    Geos = 'Geos',
    HangingBanners = 'HangingBanners',
    DigitalStreetPoleBanners = 'DigitalStreetPoleBanners',
    DigitallyDyedRugs = 'DigitallyDyedRugs',
    HeatTransferStreetPoleBanners = 'HeatTransferStreetPoleBanners',
    SilkscreenTents = 'SilkscreenTents',
    DyeSubStretchTableThrows = 'DyeSubStretchTableThrows',
    DyeSubTableThrowsAndRunners = 'DyeSubTableThrowsAndRunners',
    Digital = 'Digital',
    Silkscreen = 'Silkscreen',
    DyeSub = 'DyeSub',
    DigitalCounterMats = 'DigitalCounterMats',
    AcrylicLecterns = 'AcrylicLecterns',
    HeatTransferThrows = 'HeatTransferThrows',
    DigitalDyeSubAioKits = 'DigitalDyeSubAioKits',
    DigitalPrint = 'DigitalPrint',
    PostUpPrinting = 'PostUpPrinting',
    ArtworkApproval = 'ArtworkApproval',
    LatexPrinting = 'LatexPrinting'
}

export enum HttpVerbs {
    GET = "GET",
    POST = "POST",
    PUT = "PUT"
}

export enum StatusTypes {
    Default = "default",
    Success = "success",
    Loading = "loading",
    Error = "error"
}

export enum AudienceType {
    Unknown = 'Unknown',
    Guests = 'Guests',
    Accounts = 'Accounts'
}

export enum ItemClassificationType {
    Standalone = 'product',
    Primary = 'primary'
}

export enum RatingPaginationSortType {
    ReverseChronological = 'ReverseChronological',
    Chronological = 'Chronological',
    HighestRated = 'HighestRated',
    LowestRated = 'LowestRated',
    MostHelpful = 'MostHelpful',
    LeastHelpful = 'LeastHelpful',
    UserContentCountDesc = 'UserContentCountDesc',
}

export enum ProductEnumType {
    BuiltToOrder = "BuiltToOrder",
    StockItem = "StockItem"
}

export enum ArtworkEnumType {
    None = "None",
    PhysicalProof = "PhysicalProof",
    DigitalProof = "DigitalProof",
    NoProof = "NoProof"
}

export enum ProductStatusEnumType {
    // For unmapped values: will be either the value in the database as a string "_blank_" or "Default" for NULL value
    Default = "Default",
    Active = "Active",
    Clearout = "Clearout",
    Clearout2 = "Clearout2",
    Closeout0 = "Closeout0",
    Closeout1 = "Closeout1",
    Closeout2 = "Closeout2",
    Closeout3 = "Closeout3",
    Discontinued = "Discontinued",
    Hold = "Hold",
    NewProductPI = "NewProductPI",
    OnSale = "OnSale",
    Overstock = "Overstock",
    Terminated1 = "Terminated1",
    Terminated2 = "Terminated2",
}

export enum AccordionItemType {
    ProductDetails = "0",
    Specifications = "1",
    QuestionAndAnswers = "2",
    Reviews = "3"
}

export enum ListItemOperationType {
    Add = 'Add',
    Remove = 'Remove'
}

export enum ProductAttributeTypeValueDisplayType {
    Default = 'Default',
    NumericString = 'NumericString',
    Fraction = 'Fraction',
    String = 'String'
}

export enum PrivacyStatusType {
    Public = 'Public',
    Private = 'Private',
    Unlisted = 'Unlisted'
}

export enum UploadStatusType {
    Deleted = 'Deleted',
    Failed = 'Failed',
    Processed = 'Processed',
    Rejected = 'Rejected',
    Uploaded = 'Uploaded',
    Uploading = 'Uploading'
}

export enum VisibilityType {
    General = 'General',
    NonSite = 'NonSite'
}

export enum ItemType {
    Product = 'Product',
    ProductContainer = 'ProductContainer'
}

export enum CartServiceResponseType {
    Unknown = 'Unknown',
    Success = 'Success',
    FailedToCreateCartItem = 'FailedToCreateCartItem',
    FailedToCreateCartItemResources = 'FailedToCreateCartItemResources',
    TransientError = 'TransientError'
}

export enum MediaType {
    Image = 'Image',
    Video = 'Video'
}

export enum CrossSellListType {
    WorksWellWith = 'ProductNew | WorksWellWith',
    UsersWhoBoughtAlsoBought = 'ProductNew | UWBAB',
    RecentlyViewed = 'ProductNew | RecentlyViewed',
    Collection = 'ProductNew | Collection'
}

/**
 * The type of redirect to perform
 * @remarks This is used
 * when changing products to determine whether to perform a client side redirect or a web request to the server
 * @see useAppContext.ts
 */
export enum RedirectType {
    Client = 'Client',
    Server = 'Server'
}